import { render, staticRenderFns } from "./ProfileBonuses.vue?vue&type=template&id=715ec26e&scoped=true"
import script from "./ProfileBonuses.js?vue&type=script&lang=js&external"
export * from "./ProfileBonuses.js?vue&type=script&lang=js&external"
import style0 from "./ProfileBonuses.scss?vue&type=style&index=0&id=715ec26e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ec26e",
  null
  
)

export default component.exports